<script lang="ts">
  import type { FacetValue } from "../facet-value";
  import type { Facet, FacetOptions } from "./type.ts";
  import { List } from "../facet-value-group";

  import type { ClassValue } from "svelte/elements";
  import { addNameAndFeatureTracking, isPopular } from "./facetValues.ts";
  import { featureTrackingAttributes, removeStatusIf } from "../tracking";
  import { initToggles, isActive } from "../../toggle/Toggle.ts";
  import { updateFeatureTrackingAttribute } from "../tracking/FeatureTracking.ts";
  import { setFilterTitleMode } from "../filter";

  interface Props extends Facet, FacetOptions {
    class?: ClassValue;
  }

  let {
    name,
    title,
    values,
    id,
    featureTracking,
    visibility,
    showTitle = false,
    filterTitleMode = "onlyTitle",
    mode = "default",
    parentId = "",
    contentSnippet = defaultList,
    ...rest
  }: Props = $props();

  /*                                               */
  initToggles();

  const facetId = `facet_${id}`;

  /*                                                                                                    */
  const hidden = visibility === "hidden";

  const namedValues = $derived(values.map(addNameAndFeatureTracking(facetId, name, 1)));

  /*                                           */
  const popularValues = $derived(
    values
      .filter(isPopular)
      .map(addNameAndFeatureTracking(facetId, name, 1))
      /*                                                          */
      /*                                                                                                               */
      .map((value: FacetValue, index: number) => {
        updateFeatureTrackingAttribute(value, "status", value.checked ? "selected" : "visible");
        updateFeatureTrackingAttribute(value, "position", `${index + 1}`);
        return value;
      }),
  );

  $effect(() => {
    if (filterTitleMode === "onlyPopularValuesAndTitle" && popularValues.length === 0) {
      setFilterTitleMode(parentId, "onlyTitle");
    } else {
      setFilterTitleMode(parentId, filterTitleMode);
    }
  });
</script>

{#snippet defaultList(values: FacetValue[])}
  <List {values}></List>
{/snippet}

<fieldset
  id={facetId}
  {name}
  class={["hc_facet", rest.class]}
  data-facet-visibility={visibility}
  {...featureTrackingAttributes(removeStatusIf(hidden, featureTracking))}
  {hidden}
>
  {#if showTitle}
    <legend>
      <span>{title}</span>
    </legend>
  {/if}
  {#if mode === "sheetFirstLevel" && isActive("HEUREKA_1701_MIGRATE_ALL_FACETS_TO_SVELTE")}
    {#if popularValues.length > 0}
      <div class="hc_facet__scrollBox">
        {#if filterTitleMode === "onlyPopularValuesAndTitle"}
          {@render contentSnippet(popularValues, "unselectedPopular")}
        {/if}
      </div>
    {/if}
  {:else}
    {@render contentSnippet(namedValues)}
  {/if}
</fieldset>

<style lang="scss">
  fieldset {
    min-width: 0;

    span {
      font: var(--oc-semantic-font-copy-100);
      font-weight: 700;
    }
  }
</style>
